import styled from "styled-components";

export const PaymentSettingsWrapper = styled.div`
    // margin-left: -52px;
   // margin-top: 50px;
   width: 100%;
    .side-nav {
        flex: 0 0 205px;
        margin-right: 32px;
        .block-title {
            text-transform: uppercase;
            padding-bottom: 10px;
            padding-left: 32px;
        }
        ul {
            li {
                padding: 10px 32px;
                cursor: pointer;
                &.active {
                    box-shadow: 1px 1px 3px #ddd;
                    border-radius: 0 5px 5px 0;
                    background-color: #ED141F;
                }
            }
        }
    }
    .payment-settings-details {
        flex: 1;
    }

`
export const BlockPayInWrapper = styled.div`
    width: 100%;
    .block-pay-in {
        margin: 0 -8px;
        width: 40%;
    }
    .toggle-with-label {
        padding: 8px 16px;
        flex: 0 0 calc(33.33% - 16px);
        margin: 8px;
        height: 50px;
        box-shadow: 0 0 5px #ddd;
        border-radius: 5px;
        background-color: #fff;
        .switch {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 24px;
            input { 
                opacity: 0;
                width: 0;
                height: 0;
                &:checked + .slider {
                    background-color: #05b61d;
                }
                &:focus + .slider {
                    box-shadow: 0 0 1px #05b61d;
                }
                &:checked + .slider:before {
                    transform: translateX(16px);
                }
            }
            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #bdbdbd;
                transition: .4s;
                border-radius: 34px;
                &:before {
                    position: absolute;
                    content: "";
                    height: 18px;
                    width: 18px;
                    left: 3px;
                    bottom: 3px;
                    background-color: white;
                    -webkit-transition: .4s;
                    transition: .4s;
                    border-radius: 34px;
                }
            }
        }
    }
    .limit-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
        gap: 10px;
    }
    .limit-controls {
        display: flex;
        gap: 20px;
        align-items: center;
        .toggle-with-label {
            padding: 0;
            margin: 0;
            gap: 5px;
            align-items: center;
            white-space: nowrap;
            background-color: transparent;
            box-shadow: none;
            border: none;
        }
    }
    .toggle-with-label.disabled {
        opacity: 0.6;
        pointer-events: none;
    }
`
export const PayInAmountLimitWrapper = styled.div`
    width: 100%;
    .block-pay-in-amount-limit {
        flex-direction: column;
        width: 100%;
        margin-top: 13px;
        .col {
            flex: 1;
        }
        .form-row {
            gap: 16px;
        }
    }
        .toggle-with-label {
            padding: 8px 16px;
            flex: 0 0 calc(33.33% - 16px);
            margin: 8px;
            height: 50px;
            .switch {
                position: relative;
                display: inline-block;
                width: 40px;
                height: 24px;
                input { 
                    opacity: 0;
                    width: 0;
                    height: 0;
                    &:checked + .slider {
                        background-color: #05b61d;
                    }
                    &:focus + .slider {
                        box-shadow: 0 0 1px #05b61d;
                    }
                    &:checked + .slider:before {
                        transform: translateX(16px);
                    }
                    &:disabled + .slider {
                        cursor: not-allowed;
                    }
                }
            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #bdbdbd;
                transition: .4s;
                border-radius: 34px;
                &:before {
                    position: absolute;
                    content: "";
                    height: 18px;
                    width: 18px;
                    left: 3px;
                    bottom: 3px;
                    background-color: white;
                    -webkit-transition: .4s;
                    transition: .4s;
                    border-radius: 34px;
                }
            }
        }
    }
    .limit-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
        gap: 10px;
        .toggle-with-label {
            padding: 0;
            margin: 0;
            gap: 5px;
            align-items: center;
        }
    }
    .limit-controls {
        display: flex;
        gap: 20px;
        align-items: center;
        .toggle-with-label {
            padding: 0;
            margin: 0;
            gap: 5px;
            align-items: center;
            white-space: nowrap;
        }
    }
    .control-item {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .input-disabled {
        opacity: 0.85;
        pointer-events: none;
    }
    .input-disabled input {
        background-color: #f5f5f5 !important;
        color: #9e9e9e !important;
        cursor: not-allowed !important;
        border-color: #e0e0e0 !important;
    }
    .input-disabled input::placeholder {
        color: #bdbdbd9e !important;
    }
    .input-error .form-item {
        background: #fff5f5;
    }
    .input-error .form-item input {
        border-color: #ED141F !important;
    }
    .input-error .item-label {
        color: #ED141F !important;
    }

`

export const DashboardConfiguration = styled.div`
    width: 100%;
    .dashboard-configuration {
        background-color: #FFF;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 13%);
        padding: 20px;
        border-radius: 0 5px 5px;
        flex-direction: column;
        width: 100%;
        .col {
            flex: 1;
        }
        .form-row {
            gap: 16px;
        }

        .toggle-with-label {
            padding: 8px 16px;
            flex: 0 0 calc(33.33% - 16px);          
            height: 50px;           
            border-radius: 5px;
           
            .switch {
                position: relative;
                display: inline-block;
                width: 40px;
                height: 24px;
                input { 
                    opacity: 0;
                    width: 0;
                    height: 0;
                    &:checked + .slider {
                        background-color: #05b61d;
                    }
                    &:focus + .slider {
                        box-shadow: 0 0 1px #05b61d;
                    }
                    &:checked + .slider:before {
                        transform: translateX(16px);
                    }
                }
                .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #bdbdbd;
                    transition: .4s;
                    border-radius: 34px;
                    &:before {
                        position: absolute;
                        content: "";
                        height: 18px;
                        width: 18px;
                        left: 3px;
                        bottom: 3px;
                        background-color: white;
                        -webkit-transition: .4s;
                        transition: .4s;
                        border-radius: 34px;
                    }
                }
            }
        }
        .disabled {
            opacity: 0.5;
        }
    }

`

export const SelectedPlanWrapper = styled.div`
    position: absolute;
    width: 50%;
    right: 0;
    display: flex;
    align-items: center;
    height: fit-content;    
   justify-content: end;   
   // margin-top: 93px;
    .plan-wrap{
        padding-right: 10px;
    }
    .planbox{   
                    
        h2{
            line-height: 39px;            
            padding-right: 5px;
        }
    }
    .toggle-with-label {
        padding: 0px 16px;
        flex: 0 0 calc(33.33% - 16px);          
        height: 50px;           
        border-radius: 5px;  
        align-items: center;
        .read-only-toggle {
            pointer-events: none;
            opacity: 0.75;
        }
        .read-only-toggle .slider {
        cursor: default;
        }
        .switch {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 24px;
            input { 
                opacity: 0;
                width: 0;
                height: 0;
                &:checked + .slider {
                    background-color: #05b61d;
                }
                &:focus + .slider {
                    box-shadow: 0 0 1px #05b61d;
                }
                &:checked + .slider:before {
                    transform: translateX(16px);
                }
            }
            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #bdbdbd;
                transition: .4s;
                border-radius: 34px;
                &:before {
                    position: absolute;
                    content: "";
                    height: 18px;
                    width: 18px;
                    left: 3px;
                    bottom: 3px;
                    background-color: white;
                    -webkit-transition: .4s;
                    transition: .4s;
                    border-radius: 34px;
                }
            }
        }
        h2{                     
            padding-right: 5px;
        }
    }
    .payment-settings-reset-btn {
        background-color: #fff;
        border: 2px solid #ED141F;
        color: #ED141F;
    }
    .payment-settings-reset-btn:disabled {
        background-color: #f0f0f0;
        color: #ccc;
        cursor: not-allowed;
        border: 2px solid #ccc;
    }
`